/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {CountryCode, VATPercentage, VATValue} from './interfaces';

import {CustomVAT, DefaultVAT, MarginVAT, SplitVAT} from './vatUtil';
import countriesJson from '../../res/files/countries.json';

const countries = countriesJson as Record<string, string>;

export {countries as COUNTRIES};

const transformCountryMap: Record<string, string> = {
    Belgium: 'België',
    Germany: 'Duitsland',
    Netherlands: 'Nederland'
};

export const getCountryCode = (countryName: string): string => {
    const transformed = transformCountryMap[countryName];
    return Object.entries(countries).find(entry => entry[1] === transformed || entry[1] === countryName)?.[0] ?? 'NL';
};

export function getCountryLabel(countryCode: string) {
    return countries[countryCode] ?? '';
}

export function getVatItemsByCountry(
    countryCode: string,
    items?: Array<VATValue>,
    includeSplit: boolean = true,
    includeSpecial: boolean = true
): Array<VATValue> {
    if (!items) items = [DefaultVAT(0)];
    if (countryCode === CountryCode.BE)
        items.push(DefaultVAT(VATPercentage.BE_LOW), DefaultVAT(VATPercentage.BE_MID), DefaultVAT(VATPercentage.HIGH));
    else if (countryCode === CountryCode.DE)
        items.push(DefaultVAT(VATPercentage.DE_LOW), DefaultVAT(VATPercentage.DE_HIGH));
    else if (countryCode === CountryCode.NL)
        items.push(DefaultVAT(VATPercentage.NL_LOW), DefaultVAT(VATPercentage.HIGH));
    if (includeSpecial) {
        items.push(MarginVAT());
        if (includeSplit) items.push(SplitVAT({'21': 0, '9': 0}));
    }
    items.push(CustomVAT(0));
    return items;
}

export function transformCountryName(countryName: string): string {
    return transformCountryMap[countryName] ?? countryName;
}
